import Vue from 'vue'
import VueRouter from 'vue-router'
import axiosIns from '@axios'
import AuthWrapper from '@/auth/authWrapper.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/Home.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/Test.vue'),
      meta: {
        pageTitle: 'Test',
        breadcrumb: [
          {
            text: 'Test',
            active: true,
          },
        ],
      },
    },
    {
      path: '/products/current',
      name: 'current-products',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/CurrentProducts.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Current Products',
        breadcrumb: [
          {
            text: 'Products',
            active: true,
          },
          {
            text: 'Current Products',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product/fulldatabase',
      name: 'full-database',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/FullDatabase.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/FullDatabaseStatic.vue'),
      },
      meta: {
        pageTitle: 'Full database',
        breadcrumb: [
          {
            text: 'Full database',
            active: true,
          },
        ],
      },
    },
    {
      path: '/products/selection-records',
      name: 'selection-records',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/SelectionRecords.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Selection Records',
        breadcrumb: [
          {
            text: 'Products',
            active: true,
          },
          {
            text: 'Selection Records',
            active: true,
          },
        ],
      },
    },
    {
      path: '/marketplace/overview',
      name: 'universe-portfolio',
      redirect: { name: 'marketplace-dashboard' },
    },
    {
      path: '/marketplace/dashboard',
      name: 'marketplace-dashboard',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/portfolio/PortfolioReport.vue'),
        componentProps: {
          portfolioType: 'u',
        },
        authRequired: true,
        staticComponent: () => import('@/views/static/PortfolioReportStatic.vue'),
      },
      meta: {
        pageTitle: 'Marketplace Dashboard',
        breadcrumb: [
          {
            text: 'Marketplace Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/marketplace/trends',
      name: 'trends',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/marketplace/Trends.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Market Trends',
        breadcrumb: [
          {
            text: 'Marketplace',
            active: false,
          },
          {
            text: 'Trends',
            active: true,
          },
        ],
      },
    },
    {
      path: '/marketplace/market-reports',
      name: 'marketreports',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/marketplace/MarketReports.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Market reports',
        breadcrumb: [
          {
            text: 'Data',
            active: true,
          },
          {
            text: 'Market reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/portfolios/report/:portfolioType',
      name: 'portfolio-report',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/portfolio/PortfolioReport.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Portfolio Report',
        navActiveLink: 'my-portfolios',
        breadcrumb: [
          {
            text: 'Portfolio Report',
            active: true,
          },
        ],
      },
    },
    {
      path: '/portfolios',
      name: 'my-portfolios',
      component: AuthWrapper,
      props: {
        authRequired: true,
        component: () => import('@/views/products/portfolio/MyPortfolios.vue'),
        staticComponent: () => import('@/views/static/MyPortfoliosStatic.vue'),
      },
      meta: {
        pageTitle: 'Portfolios',
        breadcrumb: [
          {
            text: 'Portfolios',
            active: true,
          },
        ],
      },
    },
    /* {
      path: '/portfolios/report/:portfolioId',
      name: 'old-portfolio-report',
      component: () => import('@/views/lifecycle/PortfolioReport.vue'),
      props: true,
      meta: {
        pageTitle: 'Report',
        breadcrumb: [
          {
            text: 'Portfolios',
            to: { name: 'my-portfolios' },
          },
          {
            text: 'Report',
            active: true,
          },
        ],
      },
    }, */
    // TODO MISSING AUTH
    {
      path: '/portfolios/edit/:portfolioId',
      name: 'portfolio-edit',
      component: () => import('@/views/products/portfolio/EditPortfolio.vue'),
      props: true,
      meta: {
        pageTitle: 'Edit Portfolio',
        breadcrumb: [
          {
            text: 'Portfolios',
            to: { name: 'my-portfolios' },
          },
          {
            text: 'Edit',
            active: true,
          },
        ],
      },
    },
    {
      path: '/portfolios/upload-spreadsheet',
      name: 'upload-spreadsheet',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/portfolio/UploadSpreadsheet.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Upload Spreadsheet',
        breadcrumb: [
          {
            text: 'Portfolios',
            to: { name: 'my-portfolios' },
          },
          {
            text: 'Upload Spreadsheet',
            active: true,
          },
        ],
      },
    },
    {
      path: '/head-to-head',
      name: 'head-to-head',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/HeadToHead.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Head to Head',
        breadcrumb: [
          {
            text: 'Head to Head',
            active: true,
          },
        ],
      },
    },
    {
      path: '/selection-record',
      name: 'selection-record',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/SelectionRecord.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Selection Record',
        breadcrumb: [
          {
            text: 'Selection Record',
            active: true,
          },
        ],
      },
    },
    {
      path: '/selection-record/generated-record',
      name: 'generated-record',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/products/GeneratedRecord.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Generated Selection Record',
        breadcrumb: [
          {
            text: 'Selection Record',
            to: { name: 'selection-record' },
          },
          {
            text: 'Generated Record',
            active: true,
          },
        ],
      },
    },
    {
      path: '/product/report/:reportNumber',
      name: 'product-report',
      component: AuthWrapper,
      props: {
        authRequired: true,
        component: () => import('@/views/products/ProductBreakdown.vue'),
        staticComponent: () => import('@/views/static/ProductReportStatic.vue'),
      },
      meta: {
        pageTitle: 'Product Breakdown',
        breadcrumb: [
          {
            text: 'Product Breakdown',
            active: true,
          },
        ],
      },
    },
    {
      path: '/draft/report/:fvcdetailsid/fvc/:fvcpassword',
      name: 'fvc-draft-report',
      component: AuthWrapper,
      props: {
        authRequired: true,
        component: () => import('@/views/products/FVCDraft.vue'),
        staticComponent: () => import('@/views/static/ProductReportStatic.vue'),
      },
    },
    {
      path: '/draft/report/:fvcdetailsid/:providerpassword',
      name: 'provider-draft-report',
      component: AuthWrapper,
      props: {
        authRequired: false,
        component: () => import('@/views/products/ProviderDraft.vue'),
      },
    },
    {
      path: '/bespoke/report/:fvcdetailsid/:linkpassword',
      name: 'bespoke-report',
      component: AuthWrapper,
      props: {
        authRequired: false,
        component: () => import('@/views/products/PrivateReport.vue'),
      },
    },
    {
      path: '/preview/report/:reportNumber',
      name: 'pre-link-reportnumber',
      component: () => import('@/views/products/Prelink.vue'),
      props: () => ({
        mode: 'reportnumber',
      }),
    },
    {
      path: '/preview/:databaseid/:password',
      name: 'pre-link',
      component: AuthWrapper,
      props: {
        authRequired: false,
        component: () => import('@/views/products/Prelink.vue'),
      },
    },
    {
      path: '/preview/:previewid',
      name: 'pre-link-previewid',
      component: () => import('@/views/products/Prelink.vue'),
      props: () => ({
        mode: 'previewid',
      }),
    },
    {
      path: '/data/consumer-duty-focus',
      name: 'consumerdutyfocus',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/ConsumerDutyFocus.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Consumer Duty Focus',
        breadcrumb: [
          {
            text: 'Data',
            active: true,
          },
          {
            text: 'Consumer Duty Focus',
            active: true,
          },
        ],
      },
    },
    {
      path: '/data/underlyings',
      name: 'underlyings',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/Underlyings.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/ProviderDetailsStatic.vue'),
      },
      meta: {
        pageTitle: 'Underlyings',
        breadcrumb: [
          {
            text: 'Data',
            active: true,
          },
          {
            text: 'Underlyings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/data/underlyings/:uid',
      name: 'underlying-details',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/UnderlyingDetails.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/ProviderDetailsStatic.vue'),
      },
      meta: {
        pageTitle: 'Underlying Details',
        navActiveLink: 'underlyings',
        breadcrumb: [
          {
            text: 'Data',
            active: false,
          },
          {
            text: 'Underlyings',
            to: { name: 'underlyings' },
          },
          {
            text: 'Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/data/counterparties',
      name: 'issuers',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/Counterparties.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/ProviderDetailsStatic.vue'),
      },
      meta: {
        pageTitle: 'Counterparties',
        breadcrumb: [
          {
            text: 'Data',
            active: true,
          },
          {
            text: 'Counterparties',
            active: true,
          },
        ],
      },
    },
    {
      path: '/data/counterparties/:cid',
      name: 'counterparty-details',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/CounterpartyDetails.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/ProviderDetailsStatic.vue'),
      },
      meta: {
        pageTitle: 'Counterparty Details',
        navActiveLink: 'issuers',
        breadcrumb: [
          {
            text: 'Data',
            active: false,
          },
          {
            text: 'Counterparties',
            to: { name: 'issuers' },
          },
          {
            text: 'Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/data/product-types',
      name: 'product-types',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/ProductTypes.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/ProviderDetailsStatic.vue'),
      },
      meta: {
        pageTitle: 'Product Types',
        breadcrumb: [
          {
            text: 'Data',
            active: true,
          },
          {
            text: 'Product Types',
            active: true,
          },
        ],
      },
    },
    {
      path: '/data/product-types/:ptid',
      name: 'product-type-details',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/ProductTypeDetails.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/ProviderDetailsStatic.vue'),
      },
      meta: {
        pageTitle: 'Product Type Details',
        navActiveLink: 'product-types',
        breadcrumb: [
          {
            text: 'Data',
            active: false,
          },
          {
            text: 'Product Types',
            to: { name: 'product-types' },
          },
          {
            text: 'Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/providers',
      name: 'rankings',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/providers/Providers.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Providers',
        breadcrumb: [
          {
            text: 'Providers',
            active: true,
          },
        ],
      },
    },
    {
      path: '/providers/provider-details/:pid',
      name: 'content',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/providers/ProviderDetails.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/ProviderDetailsStatic.vue'),
      },
      meta: {
        pageTitle: 'Provider Details',
        navActiveLink: 'rankings',
        breadcrumb: [
          {
            text: 'Providers',
            active: false,
          },
          {
            text: 'Provider Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/providers/your-enquiries',
      name: 'your-enquiries',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/data/providers/YourEnquiries.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/static/YourEnquiriesStatic.vue'),
      },
      meta: {
        pageTitle: 'Your Enquiries',
        navActiveLink: 'your-enquiries',
        breadcrumb: [
          {
            text: 'Providers',
            active: false,
          },
          {
            text: 'Your Enquiries',
            active: true,
          },
        ],
      },
    },
    {
      path: '/help/documentation',
      name: 'documentation',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/help/Documentation.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Documentation',
        breadcrumb: [
          {
            text: 'Help',
            active: true,
          },
          {
            text: 'Documentation',
            active: true,
          },
        ],
      },
    },
    {
      path: '/help/guides',
      name: 'guides',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/help/Guides.vue'),
        authRequired: true,
        staticComponent: () => import('@/views/help/Guides.vue'),
      },
      meta: {
        pageTitle: 'Guides',
        breadcrumb: [
          {
            text: 'Help',
            active: true,
          },
          {
            text: 'Guides',
            active: true,
          },
        ],
      },
    },
    {
      path: '/help/contact-us',
      name: 'contact-us',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/help/ContactUs.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Contact Us',
        breadcrumb: [
          {
            text: 'Help',
            active: true,
          },
          {
            text: 'Contact Us',
            active: true,
          },
        ],
      },
    },
    {
      path: '/help/terms-and-conditions',
      name: 'terms-and-conditions',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/help/TermsAndConditions.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Terms and Conditions',
        breadcrumb: [
          {
            text: 'Help',
            active: true,
          },
          {
            text: 'Terms and Conditions',
            active: true,
          },
        ],
      },
    },
    {
      path: '/help/privacy-policy',
      name: 'privacy-policy',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/help/PrivacyPolicy.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Privacy Policy',
        breadcrumb: [
          {
            text: 'Help',
            active: true,
          },
          {
            text: 'Privacy Policy',
            active: true,
          },
        ],
      },
    },
    {
      path: '/help/disclaimer',
      name: 'disclaimer',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/help/Disclaimer.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Disclaimer',
        breadcrumb: [
          {
            text: 'Help',
            active: true,
          },
          {
            text: 'Disclaimer',
            active: true,
          },
        ],
      },
    },
    {
      path: '/account/account-details',
      name: 'account-details',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/AccountDetails.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Account Details',
        breadcrumb: [
          {
            text: 'Account',
            active: true,
          },
          {
            text: 'Account details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/account/your-usage',
      name: 'account-your-usage',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/YourUsage.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Usage history',
        breadcrumb: [
          {
            text: 'Account',
            active: true,
          },
          {
            text: 'Your usage',
            active: true,
          },
        ],
      },
    },
    {
      path: '/register',
      name: 'register',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/Registration/Registration.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Registration',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/register/verification',
      name: 'emailverification',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/Registration/EmailVerification.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Registration',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/register/update',
      name: 'emailchange',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/Registration/ChangeEmail.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Registration',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('@/views/ResetPassword.vue'),
    },
    {
      path: '/not-authorized',
      name: 'not-authorized',
      component: () => import('@/views/error/NotAuthorized.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/company/overview',
      name: 'companyoverview',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/companyAdmin/companyOverview.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Registration',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/company/suffix/:suffixPendingId',
      name: 'suffixapproval',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/companyAdmin/approveNewSuffix.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Registration',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/company/user-approval/:userEmail',
      name: 'user-approval',
      component: AuthWrapper,
      props: {
        component: () => import('../views/companyAdmin/userApproval.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'User approval',
        breadcrumb: [
          {
            text: 'Company',
            to: { name: 'companyoverview' },
          },
          {
            text: 'User approval',
            active: true,
          },
        ],
      },
    },
    {
      path: '/company/user/:userEmail',
      name: 'user-rejection',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/companyAdmin/rejectNewUser.vue'),
        authRequired: true,
      },
      meta: {
        pageTitle: 'Registration',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/register/suffix/request',
      name: 'suffix-request',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/Registration/RequestSuffix.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Registration',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/premium',
      name: 'learn-more-premium',
      component: AuthWrapper,
      props: {
        component: () => import('@/views/pages/PremiumLearnMore.vue'),
        authRequired: false,
      },
      meta: {
        pageTitle: 'Learn more about premium',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/fvcwebsite',
      name: 'fvcwebsite',
      beforeEnter: () => {
        window.open('https://futurevc.co.uk', '_blank')
        return false
      },
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

// Intercept 404 status code and redirect them to our 404 page
axiosIns.interceptors.response.use(
  response => response,
  error => {
    if (!error.response || !error.response.status) {
      return Promise.reject(error)
    }
    const { status } = error.response
    if (status === 404) {
      router.push({ name: 'error-404' })
    }
    return Promise.reject(error)
  },
)

export default router
